import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SarStateActionsUnion, SarActionTypes } from '@core/actions/sar_state.actions';

import { SarState } from '@app/models/sar_state';

export interface State extends EntityState<SarState> {
    loading: boolean;
    loaded: boolean;
}

export const adapter: EntityAdapter<SarState> = createEntityAdapter<SarState>({
    selectId: (sar_state: SarState) => sar_state.id
});

export const INITIAL_STATE: State = adapter.getInitialState({
    loading: false,
    loaded: false
});

export function reducer(
    state: State = INITIAL_STATE,
    action: SarStateActionsUnion
) {
    switch (action.type) {
        case SarActionTypes.Load:
            return { ...state, loading: true };

        case SarActionTypes.LoadFail:
            return { ...state, loading: false };

        case SarActionTypes.LoadSuccess:
            return { ...state, loading: false, loaded: true };

        case SarActionTypes.AddAll:
            return adapter.addAll(action.sarStates, state);

        case SarActionTypes.AddOne:
            return adapter.addOne(action.sarState, state);

        case SarActionTypes.UpdateOne:
            return adapter.updateOne({ id: action.sarState.id, changes: action.sarState }, state);

        default:
            return state;
    }
}

export const {
    selectIds,
    selectEntities,
    selectAll,
    selectTotal
} = adapter.getSelectors();

export const selectLoaded = (state: State) => state.loaded;
export const selectLoading = (state: State) => state.loading;
export const getState = createFeatureSelector<State>('sarStates');
export const getAll = createSelector(
    getState,
    selectAll
);